// extracted by mini-css-extract-plugin
module.exports = {"root":"MainLoading_root__2Vf76","loadingWrapper":"MainLoading_loadingWrapper__7CrWm"};